<template>
  <div class="laobing-user">
    <el-card>
      <div class="menu-box">
        <h2>老兵e家信息管理</h2>
        <div class="box-bd">
          <el-row :gutter="20">
            <el-col :span="3">
              <el-button type="success" @click="multipleApproval">批量通过</el-button>
            </el-col>
            <el-col :span="4">
              <el-input
                placeholder="请输入搜索内容"
                v-model="getInfo.info"
                clearable
                @clear="search(getInfo.info)"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="search(getInfo.info)"
                ></el-button>
              </el-input>
            </el-col>
          </el-row>
          <!-- 表格 -->
          <el-table
            ref="multipleTable"
            @selection-change="handleChange"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            v-loading="loading"
            :row-key="getRowKeys"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              :selectable="selectable"
            />
            <el-table-column prop="name" label="姓名" width="120">
            </el-table-column>
            <el-table-column prop="phone" label="电话" width="150">
            </el-table-column>
            <el-table-column prop="id_card" label="身份证" width="200">
            </el-table-column>
            <el-table-column prop="health" label="健康状况" width="120">
            </el-table-column>
            <el-table-column prop="emergency_contact" label="紧急联系人" width="150">
            </el-table-column>
            <el-table-column prop="emergency_phone" label="紧急联系方式" width="150">
            </el-table-column>
            <el-table-column prop="relation_ship" label="与本人关系" width="120">
            </el-table-column>
            <el-table-column prop="status_text" label="审核状态" width="120">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 0" type="warning">未审核</el-tag>
                <el-tag v-else-if="scope.row.status === 1" type="success">审核通过</el-tag>
                <el-tag v-else-if="scope.row.status === 2" type="danger">审核拒绝</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="审核理由" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="180">
              <template slot-scope="scope">
                {{ formatDate(scope.row.create_time) }}
              </template>
            </el-table-column>
            <el-table-column prop="update_time" label="更新时间" width="180">
              <template slot-scope="scope">
                {{ formatDate(scope.row.update_time) }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300" >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status === 0"
                  size="mini"
                  type="success"
                  icon="el-icon-check"
                  @click="pass(scope.row)"
                  >通过</el-button
                >
                <el-button
                  v-if="scope.row.status === 0"
                  size="mini"
                  type="danger"
                  icon="el-icon-close"
                  @click="decline(scope.row)"
                  >拒绝</el-button
                >
                <el-button
                  size="mini"
                  icon="el-icon-search"
                  @click="openDetail(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @current-change="pageChange"
            @size-change="sizeChange"
            :page-sizes="[30, 60, 100]"
            :pager-count="15"
            layout="total, sizes, prev, pager, next"
            :page-size="this.getInfo.page_num"
            background
            :total="exp.num"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
    <!-- 详情对话框 -->
    <el-dialog
      title="老兵信息详情"
      :before-close="handleClose"
      :visible.sync="detailDialogVisible"
      width="80%"
    >
      <el-descriptions>
        <el-descriptions-item label="姓名">{{ detailInfo.name }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{ detailInfo.phone }}</el-descriptions-item>
        <el-descriptions-item label="身份证">{{ detailInfo.id_card }}</el-descriptions-item>
        <el-descriptions-item label="健康状况">{{ detailInfo.health }}</el-descriptions-item>
        <el-descriptions-item label="紧急联系人">{{ detailInfo.emergency_contact }}</el-descriptions-item>
        <el-descriptions-item label="紧急联系方式">{{ detailInfo.emergency_phone }}</el-descriptions-item>
        <el-descriptions-item label="与本人关系">{{ detailInfo.relation_ship }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag v-if="detailInfo.status === 0" type="warning">未审核</el-tag>
          <el-tag v-else-if="detailInfo.status === 1" type="success">审核通过</el-tag>
          <el-tag v-else-if="detailInfo.status === 2" type="danger">审核拒绝</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="审核理由">{{ detailInfo.remark }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDate(detailInfo.create_time) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatDate(detailInfo.update_time) }}</el-descriptions-item>
      </el-descriptions>
      
      <h3 style="margin: 20px 0 10px 0;">老兵经历信息</h3>
      <el-table :data="experienceList" style="width: 100%" border>
        <el-table-column prop="start_date" label="开始日期" width="150"></el-table-column>
        <el-table-column prop="end_date" label="结束日期" width="150"></el-table-column>
        <el-table-column prop="place" label="地点" width="200"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
        <el-table-column label="附件" min-width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.file && scope.row.file.length > 0">
              <el-image
                v-for="(file, index) in scope.row.file"
                :key="index"
                :src="file.path"
                :preview-src-list="getPreviewList(scope.row.file)"
                style="width: 100px; height: 100px; margin-right: 10px;"
              ></el-image>
            </div>
            <span v-else>无附件</span>
          </template>
        </el-table-column>
      </el-table>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Breadcrumb from '@/components/breadcrumb.vue'
import {
  getLeifengList,
  getLeifengDetail,
  auditLeifengPass,
  auditLeifengReject,
} from '@/api/zhiqing/laobing.js'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Breadcrumb,
  },
  data() {
    //这里存放数据
    return {
      loading: false,
      //总页数
      exp: {
        count: Number,
        num: 0,
      },
      //当前页码
      getInfo: {
        //搜索框
        info: '',
        page_code: 1,
        page_num: 15,
      },
      //表格数据
      tableData: [],
      //选中的行
      checkedItem: [],
      //详情对话框显示
      detailDialogVisible: false,
      //详情信息
      detailInfo: {},
      //老兵经历列表
      experienceList: [],
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //获取行ID
    getRowKeys(row) {
      return row.id
    },
    //格式化时间
    formatDate(timestamp) {
      if (!timestamp) return ''
      if (typeof timestamp === 'string') {
        return timestamp
      }
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    //修改每页数量
    sizeChange(value) {
      this.getInfo.page_num = value
      this.getLeifengList()
    },
    //分页切换
    pageChange(value) {
      this.getInfo.page_code = value
      this.getLeifengList()
    },
    //搜索事件
    search(e) {
      this.getInfo.page_code = 1
      this.getLeifengList()
    },
    //选择行变化
    handleChange(val) {
      this.checkedItem = val
    },
    //是否可选择
    selectable(row) {
      return row.status === 0
    },
    //批量通过
    multipleApproval() {
      if (this.checkedItem.length === 0) {
        this.$message.warning('请选择需要通过的申请！')
      } else {
        this.$confirm('确认批量通过申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
        })
          .then(async () => {
            const ids = this.checkedItem.map(item => item.id)
            await this.approvePass(ids)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
            })
          })
      }
    },
    //通过审核
    async pass(row) {
      this.$confirm('确认通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      })
        .then(async () => {
          await this.approvePass([row.id])
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          })
        })
    },
    //拒绝审核
    async decline(row) {
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async ({ value }) => {
          await this.approveDecline([row.id], value)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消拒绝',
          })
        })
    },
    //审核通过API
    async approvePass(ids) {
      try {
        const { data: res } = await auditLeifengPass({ ids })
        if (res.code === 200) {
          this.$message.success('审核通过成功！')
          this.$refs.multipleTable.clearSelection()
          this.getLeifengList()
        } else {
          this.$message.error(res.message || '审核失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      }
    },
    //审核拒绝API
    async approveDecline(ids, remark) {
      try {
        const { data: res } = await auditLeifengReject({ ids, remark })
        if (res.code === 200) {
          this.$message.success('拒绝审核成功！')
          this.$refs.multipleTable.clearSelection()
          this.getLeifengList()
        } else {
          this.$message.error(res.message || '拒绝失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      }
    },
    //打开详情
    async openDetail(row) {
      this.detailDialogVisible = true
      try {
        const { data: res } = await getLeifengDetail({ id: row.id })
        if (res.code === 200) {
          this.detailInfo = res.data.user_info
          this.experienceList = res.data.list
        } else {
          this.$message.error(res.message || '获取详情失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      }
    },
    //关闭详情对话框
    handleClose() {
      this.detailDialogVisible = false
      this.detailInfo = {}
      this.experienceList = []
    },
    //获取图片预览列表
    getPreviewList(files) {
      return files.map(file => file.path)
    },
    //获取老兵列表
    async getLeifengList() {
      this.loading = true
      try {
        const { data: res } = await getLeifengList(this.getInfo)
        if (res.code === 200) {
          this.tableData = res.data.data
          this.exp.num = res.data.total
        } else {
          this.$message.error(res.message || '查询失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getLeifengList()
  },
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.page {
  margin-top: 20px;
}
.el-pagination {
  margin-top: 20px;
  text-align: right;
}
.menu-box h2 {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
}
.box-bd {
  margin-top: 20px;
}
</style>